import React from "react";

import { CampoEstatico } from "@intechprev/componentes-web";

interface IProps {
  contrib: any | null;
}

export const Contribuicao: React.FC<IProps> = ({
  contrib
}) => {

  function AjustarDisplayCasasDecimais(percentual: number, casas: number) {
    const p = percentual.toString().split(".");

    // se nao tiver casa decimal
    if (p.length === 1) {
      return `${p[0]},0000`;
    }
    // re tiver menos de 2 digitos add 0s
    console.log(p[1]);
    if (p[1].length < casas) {
      let percFinal = p[1];
      while (percFinal.length < casas) {
        percFinal = percFinal + "0";
      }
      return `${p[0]},${percFinal}`;
    }
    // se tiver mais de 2 digitos mantem
    return percentual.toString().replace(".", ",");
  }

  return (
    <tr >
      <td>{contrib.DS_TIPO_CONTRIBUICAO}</td>
      <td className={"text-right"}>
        <CampoEstatico valor={contrib.CONTRIB_PARTICIPANTE.toLocaleString("pt-Br")} />
      </td>
      <td className={"text-right"}>
        <CampoEstatico valor={contrib.CONTRIB_EMPRESA.toLocaleString("pt-Br")} />
      </td>
      <td className={"text-right"}>
        {contrib.SEQ_CONTRIBUICAO !== 0 ?
          <CampoEstatico valor={AjustarDisplayCasasDecimais(contrib.SEQ_CONTRIBUICAO, 4)} /> :
          <CampoEstatico valor={"-"} />
        }
      </td>
    </tr>
  )
}